import React from "react";
import TermsandConditions from "../Components/Terms/TermsandConditions";

const TermsConditions:React.FC = () => {
  return (
    <>
      <TermsandConditions />
    </>
  );
};

export default TermsConditions;
